export default __webpack_public_path__ + "static/referralprogram-c187a2f74e5dbcdf04ed9a83161a5142.png";